module.exports = __webpack_public_path__ + "img/Pratical Experts.06ff6dc7.png";